/**
 * @prettier
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { withComponentLabel } from '../../utils/debug'

const CategoryListCollectionRefactor = ({ collection, type }) => {
  return (
    <>
      {collection.length ? (
        collection.map((collectionItem, index) => (
          <Link
            to={`/${type}/${collectionItem._id}`}
            className="flex h-20 border-2 text-gray-700"
            key={index}
          >
            {/* image placeholder */}
            <div className="h-16 w-16 my-auto mx-3 bg-gray-300"></div>
            {/* text wrapper */}
            <div className="flex flex-col mt-2 gap-2 ">
              <div className="ml-1 text-2xl">{collectionItem.name}</div>
              <div className="flex">
                <div className="flex items-center mr-1">
                  {/* {secondaryContent} */}
                </div>
                <div className="flex items-end text-xs text-gray-600">
                  {/* {secondaryContentText} */}
                </div>
              </div>
            </div>
          </Link>
        ))
      ) : (
        <div className="flex text-gray-600 border-y-2 py-4">
          <div className="w-full text-center">
            <div className="text-4xl md:text-6xl">😕</div>
            <div className="text-xl md:text-2xl">Nothing here yet...</div>
          </div>
        </div>
      )}
    </>
  )
}

export default withComponentLabel(
  CategoryListCollectionRefactor,
  'CategoryListCollectionRefactor'
)
